var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],staticClass:"new-issue-for-discussion discussion-create-issue-btn gl-w-full sm:gl-w-auto",attrs:{"href":_vm.url,"title":_vm.$options.i18n.buttonLabel,"aria-label":_vm.$options.i18n.buttonLabel,"icon":"issue-new"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }